export default "__VITE_ASSET__D77f26vb__"